var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user_1_",
    "data-name": "user (1)",
    d: "M27.313,4.686A16,16,0,0,0,4.686,27.314,16,16,0,0,0,27.313,4.686ZM6.944,26.831A9.154,9.154,0,0,1,16,18.775a9.119,9.119,0,0,1,9.056,8.055,14.1,14.1,0,0,1-18.112,0ZM16,16.844a4.86,4.86,0,1,1,4.86-4.86A4.865,4.865,0,0,1,16,16.844Zm10.67,8.4a11.022,11.022,0,0,0-6.9-7.684,6.735,6.735,0,1,0-7.539,0,11.012,11.012,0,0,0-6.9,7.681,14.125,14.125,0,1,1,21.341,0Zm0,0",
    transform: "translate(0.001)",
    fill: "#329bc9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser1);
export default __webpack_public_path__ + "static/media/user (1).69d3d6939b06462a7865f4ae9cde0359.svg";
export { ForwardRef as ReactComponent };